<template>
  <div class="table-responsive">
    <table
      class="table table-striped table-sm table-bordered fs-sm"
      :id="dataTable.id"
    >
      <thead>
        <tr>
          <th>Cliente</th>
          <th>Projeto</th>
          <th>Tipo Escopo</th>
          <th>Tipo Projeto</th>
          <th class="text-center">Franquia</th>
          <th class="text-center">Franquia Acumulada</th>
          <th class="text-center">Status</th>
          <th class="text-center">Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="client in clients" :key="client.id">
          <td>{{ client.codCliente }} - {{ client.nome }}</td>
          <td>{{ client.codProjeto }} - {{ client.descricao }}</td>
          <td>{{ client.tipoEscopo }}</td>
          <td>{{ client.tipoProjeto }}</td>
          <td v-html="optionsTranslate(client.franquia)" class="text-center" />
          <td
            v-html="optionsTranslate(client.franquiaAcumulada)"
            class="text-center"
          />
          <td v-html="statusTranslate(client.status)" class="text-center" />
          <td class="text-center p-2">
            <div>
              <button
                type="button"
                class="btn btn-outline-warning btn-icon"
                title="Editar"
                @click="$emit('createEditClient', client.id)"
              >
                <i class="ph ph-pencil" />
              </button>
              <button
                type="button"
                class="btn btn-outline-dark btn-icon ms-2"
                title="Contatos"
                @click="$emit('contactsClient', client.id)"
              >
                <i class="ph ph-users" />
              </button>
            </div>
            <div v-if="client.status == 1" class="mt-2">
              <button
                type="button"
                class="btn btn-outline-success btn-icon"
                title="Finalizar Projeto"
                @click="$emit('finalizeClient', client.id)"
              >
                <i class="ph ph-check" />
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import '@/utils/basicDataTableExtend'
import { optionsTranslate, statusTranslate } from '@/utils/strings'
import { createColumnFilter } from '@/utils/dataTableFilters'

export default {
  name: 'ListClients',

  props: {
    clients: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      table: null,
      dataTable: {
        id: 'dataTableListClients',
        columnDefs: [
          {
            targets: [7],
            width: 120,
            orderable: false,
          },
        ],
        order: [
          [6, 'asc'],
          [0, 'asc'],
        ],
      },
      optionsTranslate,
      statusTranslate,
    }
  },

  methods: {
    createDataTable() {
      if (this.table) {
        this.table.destroy()
      }

      const self = this

      this.table = window.$(`#${this.dataTable.id}`).DataTable({
        columnDefs: this.dataTable.columnDefs,
        order: this.dataTable.order,
        initComplete() {
          const api = this.api()
          const thead = window.$(`#${self.dataTable.id} thead`)

          const filterConfig = [
            { index: 0, type: 'input' },
            { index: 1, type: 'input' },
            { index: 2, type: 'input' },
            { index: 3, type: 'input' },
            {
              index: 4,
              type: 'select',
              options: [
                { value: '', text: 'Selecione' },
                { value: 'Sim', text: 'Sim' },
                { value: 'Não', text: 'Não' },
              ],
            },
            {
              index: 5,
              type: 'select',
              options: [
                { value: '', text: 'Selecione' },
                { value: 'Sim', text: 'Sim' },
                { value: 'Não', text: 'Não' },
              ],
            },
            {
              index: 6,
              type: 'select',
              options: [
                { value: '', text: 'Selecione' },
                { value: 'Ativo', text: 'Ativo' },
                { value: 'Inativo', text: 'Inativo' },
              ],
            },
          ]

          createColumnFilter(api, thead[0], filterConfig)
        },
      })
    },
  },

  mounted() {
    this.createDataTable()
  },
}
</script>
